<template>
  <div>
    <form @submit.prevent="updateSimilar">
      <div class="flex">
        <div class="mb-4 p-4">
          <label
            class="block text-gray-700 text-sm font-bold mb-2"
            for="username"
            >DETYRAT E PERBASHKETA</label
          >
          <input
            class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            v-model="fridaySimilarTask.name"
          />
        </div>
        <div class="mb-4 p-4">
          <label
            class="block text-gray-700 text-sm font-bold mb-2"
            for="username"
            >K/P/0</label
          >
          <div class="relative">
            <select
              class="shadow appearance-none border rounded w-auto py-2 px-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              v-model="fridaySimilarTask.status"
            >
              <option>K</option>
              <option>P</option>
              <option>0</option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="mb-4 p-4">
          <label
            class="block text-gray-700 text-sm font-bold mb-2"
            for="username"
            >AM/PM</label
          >
          <div class="relative">
            <select
              class="shadow appearance-none border rounded w-auto py-2 px-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              v-model="fridaySimilarTask.time"
            >
              <option>AM</option>
              <option>PM</option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="mb-4 p-4">
          <label
            class="block text-gray-700 text-sm font-bold mb-2"
            for="username"
            >COMMENT</label
          >
          <textarea
            class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            v-model="fridaySimilarTask.comment"
            :required="fridaySimilarTask.status === 'P'"
          ></textarea>
        </div>
        <div class="mb-4 p-4">
          <label
            class="block text-gray-700 text-sm font-bold mb-2"
            for="username"
            >DATE</label
          >
          <input
            type="date"
            class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            v-model="fridaySimilarTask.day"
          />
        </div>
        <div class="mb-4 p-4">
          <label
            class="block text-gray-700 text-sm font-bold mb-2"
            for="username"
            >SHFAQ EKRAN</label
          >
          <input
            type="checkbox"
            v-model="fridaySimilarTask.shfaq_ekran"
            :class="fridaySimilarTask.shfaq_ekran === '1' ? 'checked' : ''"
          />
        </div>
        <div class="mb-4 pt-12">
          <div class="p-1">
            <button
              type="submit"
              class="block text-center uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
            >
              Ndrysho
            </button>
          </div>
          <div class="p-1">
            <router-link
              to="/excel#friday"
              class="block text-center uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
              >Kthehu</router-link
            >
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      fridaySimilarTask: {},
      shfaq_ekran: false,
      id: this.$route.params.id,
    };
  },
  created() {
    this.getSimilarTask();
  },
  methods: {
    getSimilarTask() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(`${process.env.VUE_APP_API}/excel/detyrat-perb/${this.id}`)
        .then((response) => {
          this.fridaySimilarTask = response.data;
          console.log(response);
        })
        .catch((error) => console.log(error));
    },
    updateSimilar() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .put(
          `${process.env.VUE_APP_API}/excel/detyrat-perb/${this.id}/update`,
          {
            name: this.fridaySimilarTask.name,
            status: this.fridaySimilarTask.status,
            time: this.fridaySimilarTask.time,
            comment: this.fridaySimilarTask.comment,
            day: this.fridaySimilarTask.day,
            shfaq_ekran: this.fridaySimilarTask.shfaq_ekran ? 1 : 0,
            user_id: this.fridaySimilarTask.user_id
          }
        )
        .then(this.$router.push("/excel"))
        .then(
          this.$notify({
            group: "address",
            title: "Detyra e perbashket",
            text: "Detyra e perbashket u ndryshua",
          })
        )
        .catch((error) => console.log(error));
    },
  },
};
</script>

<style></style>
